import { useTranslation } from 'react-i18next';
import { classNames } from '@utils/classNames';
import { ParameterListHeaderItem } from './ParameterListHeaderItem';

type ParameterListHeaderProps = {
  className?: string;
};

export const ParameterListHeader = ({
  className,
}: ParameterListHeaderProps) => {
  const { t } = useTranslation('component', { keyPrefix: 'parameterList' });

  return (
    <div
      className={classNames(
        'hidden xl:flex print:flex items-center p-2.5 xl:p-5 print:p-5 gap-8 bg-grey3light rounded-bonusLarge',
        className,
      )}
    >
      <ParameterListHeaderItem
        label={t('parameter')}
        className="flex-[0_0_15%] min-w-[280px]"
      />
      <div className="flex-1 flex">
        <ParameterListHeaderItem
          label={t('value')}
          className="flex-[0_0_15%] min-w-[80px]"
        />
        <ParameterListHeaderItem
          label={t('evaluation')}
          className="flex-1 ml-12"
        />
      </div>
      <ParameterListHeaderItem
        label={t('status')}
        className="flex-[0_0_15%] text-right"
      />
    </div>
  );
};
